import moment from "moment";

import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { MachineStatus } from "../../layouts/machineStatus";

interface MachineStatus {
  data?:
    | any
    | {
        code?: number;
        msg?: string;
        hosts?: any[];
      };
  lastUpdatedTime: string;
  loading: boolean;
  websocketStatus: string;
}

const initialState: MachineStatus = {
  data: "",
  lastUpdatedTime: "",
  loading: true,
  websocketStatus: "closed",
};

export const providerStatusSlice = createSlice({
  name: "providerStatus",
  initialState,
  reducers: {
    updateProviderMachinesLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    updateActiveProviderMachines: (state, action) => {
      const newHost = action.payload;
      console.log("newHost", newHost);

      if (typeof newHost !== "object" || !newHost?.host_id) {
        return;
      }

      // Ensure state.data is an object, not a string or something else
      if (typeof state.data !== "object" || state.data === null) {
        state.data = { hosts: [] };
      }

      // Ensure hosts array exists
      if (!Array.isArray(state.data.hosts)) {
        state.data.hosts = [];
      }

      const index = state.data.hosts.findIndex(
        (item: any) => item.host_id === newHost.host_id
      );

      if (index !== -1) {
        // Update existing host
        state.data.hosts[index] = newHost;
      } else {
        // Add new host
        state.data.hosts.push(newHost);
      }
    },
    updateLastTime: (state) => {
      state.lastUpdatedTime = moment().format("MM/DD/YYYY h:mm:ss a");
    },
    updateWebsocketStatus: (state, action: PayloadAction<string>) => {
      state.websocketStatus = action.payload;
    },
    removeProviderMachines: (state) => {
      return initialState;
    },
  },
});

export const {
  updateProviderMachinesLoading,
  updateActiveProviderMachines,
  updateLastTime,
  updateWebsocketStatus,
  removeProviderMachines,
} = providerStatusSlice.actions;

export default providerStatusSlice.reducer;
